/**
 * Returns a subset of generally spreadable props. "Generally spreadable" props include props that
 * start with `data-` or `aria-`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- best way to represent "any object" in this case; see https://github.com/microsoft/TypeScript/issues/15300
export const pickAriaAndDataProps = (props: Record<string, any>) =>
  Object.entries(props)
    .filter(([key]) => key.startsWith('data-') || key.startsWith('aria-'))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
